export default __webpack_public_path__ + "navigation-examples-location-snapping-thumbnail-480-fc6da2b381c18117838dc8047d9b2fa3.png";